export const LOGIN = 'login';
export const URL_LOGIN = 'urlLogin';
export const BACK_TO_ADMIN = 'backToAdmin';
export const LOGIN_AS_STUDENT = 'loginAsStudent';
export const LOGOUT = 'logout';
export const RENEW = 'renew';
export const UPDATE = 'update';
export const UPDATE_PASSWORD = 'updatePassword';
